import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import UtilsUrl from "../../utils/UtilsUrl";
import api from "./../api";

// const UtilsUrl.marketingURL() = "http://localhost:8080/campagneReseauxSociaux";

class CampagneReseauxSociauxService {
  //Afficher List CampagneReseauxSociaux
  AfficherListCampagneReseauxSociaux(idUser) {
    return api.get(UtilsUrl.marketingURL() + "/campagneReseauxSociaux/getAll/" + idUser);
  }

  //Afficher List Objectifs
  AfficherListObjectifs() {
    return api.get(UtilsUrl.marketingURL() + "/campagneReseauxSociaux/getObjectifs");
  }

  //Afficher List Types
  AfficherListTypes() {
    return api.get(UtilsUrl.marketingURL() + "/campagneReseauxSociaux/getTypes");
  }

  //Afficher List CanalDiffusion
  AfficherListCanalDiffusion() {
    return api.get(UtilsUrl.marketingURL() + "/campagneReseauxSociaux/getCanalDiffusions");
  }

  //Afficher List Statut
  AfficherListStatus() {
    return api.get(UtilsUrl.marketingURL() + "/campagneReseauxSociaux/getStatus");
  }

  // Obtenir la liste des ID de photos dans uneCampagneReseauxSociaux
  getCampagneReseauxSociauxPhotosId(id) {
    return api.get(UtilsUrl.marketingURL() + "/campagneReseauxSociaux/ListImages/" + id);
  }

  // Afficher une image par son ID
  showImage(imageId) {
    return api
      .get(UtilsUrl.marketingURL() + "/campagneReseauxSociaux/showImage/" + imageId, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const arrayBufferView = new Uint8Array(response.data);
        const blob = new Blob([arrayBufferView], {
          type: response.headers["content-type"],
        });
        const imageUrl = URL.createObjectURL(blob);
        return imageUrl;
      });
  }

  //ajouterCampagneReseauxSociaux
  ajouterCampagneReseauxSociaux(nouvelleCampagneReseauxSociaux, images) {
    const formData = new FormData();

    formData.append(
      "idUser",
      getCurrentUserId()
    );
    formData.append(
      "campagneReseauxSociaux",
      JSON.stringify(nouvelleCampagneReseauxSociaux)
    );

    for (let i = 0; i < images.length; i++) {
      formData.append("images", images[i]);
    }
    return api.post(UtilsUrl.marketingURL() + "/campagneReseauxSociaux/Add", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
  //mettreAJourCampagneReseauxSociaux
  mettreAJourCampagneReseauxSociaux(
    updatedCampagneReseauxSociaux,
    images,
    CampagneReseauxSociauxId
  ) {
    const formData = new FormData();
    formData.append(
      "campagneReseauxSociaux",
      JSON.stringify(updatedCampagneReseauxSociaux)
    );
    for (let i = 0; i < images.length; i++) {
      formData.append("images", images[i]);
    }
    return api.put(
      UtilsUrl.marketingURL() + "/campagneReseauxSociaux/update/" + CampagneReseauxSociauxId,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the content type to multipart/form-data
        },
      }
    );
  }

  //supprimerCampagneReseauxSociaux
  supprimerCampagneReseauxSociaux(CampagneReseauxSociauxId) {
    return api.put(
      UtilsUrl.marketingURL() + "/campagneReseauxSociaux/delete/" + CampagneReseauxSociauxId,
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the content type to multipart/form-data
        },
      }
    );
  }

  //getCampagneReseauxSociaux By ID
  getCampagneReseauxSociauxByID(CampagneReseauxSociauxId) {
    return api.get(UtilsUrl.marketingURL() + "/campagneReseauxSociaux/get/" + CampagneReseauxSociauxId);
  }

  //filtre
  getCampagneReseauxSociauxByFiltre(
    nom,
    canalDiffusion,
    type,
    statut,
    startDate,
    endDate
  ) {
    return api.get(
      UtilsUrl.marketingURL() +
      "/filtre?nom=" +
      nom +
      "&type=" +
      type +
      "&canalDiffusion=" +
      canalDiffusion +
      "&statut=" +
      statut +
      "&startDate=" +
      startDate +
      "&endDate=" +
      endDate
    );
  }

  //CSV Methodes
  ImporterCSV(file) {
    return api.post(UtilsUrl.marketingURL() + "/campagneReseauxSociaux/importcsv", file);
  }

  Exportcsv(nom, canalDiffusion, type, startDate, endDate) {
    return api.get(
      UtilsUrl.marketingURL() +
      "/campagneReseauxSociaux/exportcsv?nom=" +
      nom +
      "&type=" +
      type +
      "&canalDiffusion=" +
      canalDiffusion +
      "&startDate=" +
      startDate +
      "&endDate=" +
      endDate,
      {
        responseType: "blob",
      }
    );
  }
}

export default new CampagneReseauxSociauxService();
